import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Paper, Typography, Box, LinearProgress } from '@mui/material';
import { MdContentCopy, MdDownload, MdEdit, MdAdd } from 'react-icons/md';

import { BudgetTable } from './BudgetTable';
import { BudgetInfo } from './BudgetInfo';
import { CopyBudgetModal } from './CopyBudgetModal';
import { useTableDataContext } from './NewBudget/EditBudgetV2/context/EditingTableDataContext';

import api, { authHeader } from '../../../../../../services/API/apiConfig';

import {
  BtnSecondaryStyled,
  BtnStyled,
  DefaultPageStyled,
  RootStyled,
  ButtonsContainer,
  LoadingProgressStyled,
} from './ConstructionBudgets.styles';

export function ConstructionBudgets() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [constructionData, setConstructionData] = useState([]);
  const [constructions, setConstructions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [budget, setBudget] = useState(false);
  const [items, setItems] = useState([]);
  const [headerInfo, setHeaderInfo] = useState({});
  const [copyBudget, setCopyBudget] = useState(null);
  const [exportKey, setExportKey] = useState();

  const [loading, setLoading] = useState(true);

  const { updateTableData } = useTableDataContext();

  useEffect(() => {
    api
      .get(`/constructions/${id}/budgets?array=false`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        if (data.items !== undefined) {
          setBudget(true);
          setItems(data.items);
        }
      });
  }, [id]);

  useEffect(() => {
    async function getBudget() {
      await api
        .get(`/constructions/${id}/details?budget=false`, {
          headers: authHeader(),
        })
        .then((res) => setHeaderInfo(res.data.data));
    }
    getBudget();
  }, [id]);

  useEffect(() => {
    const getConstruction = async () => {
      const { data } = await api.get(`/constructions/${id}`, {
        headers: authHeader(),
      });
      setConstructionData(data.data);
      setExportKey(data.data.export_key);
    };

    getConstruction();

    setTimeout(() => {
      api
        .get('/constructions', {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setConstructions(data);
        });
    }, 1500);
  }, []);

  useEffect(() => {
    const tempArr = [];
    if (!budget && constructions.length) {
      for (let i = 0; i < constructions.length; i += 1) {
        api
          .get(`/constructions/${constructions[i].id}/budgets?array=true`, {
            headers: authHeader(),
          })
          .then((res) => {
            const { data } = res.data;

            if (data.id) {
              tempArr.push(constructions[i]);
            }
          });
      }
      setConstructions(tempArr);
    }
  }, [constructions, budget]);

  useEffect(() => {
    if (constructions.length) {
      setLoading(false);
    }
  }, [constructions]);

  const exportBudget = async () => {
    await api
      .get(`constructions/${id}/budget_xlsx?export_key=${exportKey}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { baseURL, url } = res.config;
        window.open(`${baseURL}/${url}`);
      });
  };

  const handleGoToNewBudget = () => {
    updateTableData({
      square_meter: 0,
      items_attributes: [],
      construction: constructionData.name,
    });
    localStorage.setItem('constructionId', id);
    navigate('/new-budget');
  };

  const handleCopyBudgetChange = (event) => {
    setCopyBudget(event.target.value);
  };

  const handleCopyFromBudget = (withValues) => {
    localStorage.setItem('constructionId', id);
    localStorage.setItem('copyWithValues', withValues);
    navigate(`/new-budget/${copyBudget}`);
  };

  if (loading) {
    return (
      <LoadingProgressStyled>
        <Typography variant="h2" style={{ fontSize: 32 }}>
          Carregando...
        </Typography>
        <LinearProgress style={{ width: '80%' }} />
      </LoadingProgressStyled>
    );
  }

  return (
    <>
      <Paper sx={{ minHeight: '440px' }}>
        <RootStyled>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ marginTop: '16px' }}>
              <Typography style={{ fontSize: '24px' }} variant="h1">
                {constructionData.name}
              </Typography>
              {budget && (
                <Box sx={{ marginTop: '16px' }}>
                  <BudgetInfo info={headerInfo} />
                </Box>
              )}
            </Box>

            <ButtonsContainer>
              <BtnSecondaryStyled
                id="export-budget"
                variant="outlined"
                onClick={() => (budget ? exportBudget() : setOpenModal(true))}
                disabled={budget ? !items.length : loading}
                startIcon={budget ? <MdDownload /> : <MdContentCopy />}
              >
                {budget ? 'Download' : 'Copiar orçamento'}
              </BtnSecondaryStyled>
              <BtnStyled
                id="edit-budget"
                variant="contained"
                onClick={() =>
                  budget ? navigate(`/budget/${id}`) : handleGoToNewBudget()
                }
                startIcon={budget ? <MdEdit /> : <MdAdd />}
              >
                {budget ? 'Editar' : 'Novo orçamento'}
              </BtnStyled>
            </ButtonsContainer>
          </Box>
          <DefaultPageStyled>
            <BudgetTable />
          </DefaultPageStyled>
        </RootStyled>
      </Paper>
      <CopyBudgetModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleCopyBudgetChange={handleCopyBudgetChange}
        copyBudget={copyBudget}
        handleCopyFromBudget={handleCopyFromBudget}
        loading={loading}
        constructions={constructions}
      />
    </>
  );
}
